import React, {memo} from "react";
import {Typography} from "components/Shared/Typography";
import "./styles.scss";

import useExpertsCountrySelectors from "redux/selectors/expertsCountrySelectors";
import {ExpertCardNew} from "./ExpertCardNew";
import {useTranslation} from "react-i18next";

const CountryWiseExperts = () => {
  const {selectedExpertsList} = useExpertsCountrySelectors();
  const {t} = useTranslation();

  return (
    selectedExpertsList && (
      <div>
        <img
          src={
            "https://thumbs.dreamstime.com/z/taj-mahal-agra-india-morning-light-reflection-water-uttar-pradesh-108954918.jpg"
          }
          alt="country-img"
          className="cover_image"
          height={250}
        />
        <div className="country_wise_expert">
          <div className="title_section">
            <div className="flag_mask">
              <img
                src={`https://flagcdn.com/${(selectedExpertsList?.country?.code).toLowerCase()}.svg`}
                width="150"
                height="100"
                alt="South Africa"
              />
            </div>
            <div className="details_area">
              <Typography variant="" className="country_name" component="div">
                {t("countries." + selectedExpertsList?.country?.name)}
              </Typography>
              <Typography variant="" className="expert_count" component="div">
                <span>{selectedExpertsList?.expert_count}</span>{" "}
                {`${t("expertCountry.label.expertsFrom")}`}
              </Typography>
            </div>
          </div>
          <Typography variant="" className="sub_heading" component="div">
            {t("expertCountry.header.listOfExperts")}
          </Typography>
          {selectedExpertsList?.expert_count <= 0 ? (
            <div className='empty_row'>No Experts Available</div>
          ) : (
            selectedExpertsList?.experts?.map((expert: any, i: number) => (
              <ExpertCardNew key={i} expert={expert} country={selectedExpertsList?.country}/>
            ))
          )}
        </div>
      </div>
    )
  );
};


export default memo(CountryWiseExperts);
